<template>
  <a-row style="height:100%;" type="flex">
    <a-col span="14" style="flex:1;height:100%;">
      <div style="position:relative">
        <a-row
          class="header"
          type="flex"
          justify="space-between"
          align="middle"
        >
          <a-col>
            <h3>
              {{ name }}
              <span v-if="currentConversation.type === 'GROUP'"
                >（{{ currentConversation.groupProfile.memberNum }}人）</span
              >
            </h3>
          </a-col>
          <a-col
            :class="postcard ? 'arr-box right' : 'arr-box left'"
            title="职位"
            @click="showPostCard"
          >
            <a-icon type="left" class="arrow" />
          </a-col>
        </a-row>
        <div class="message-box" ref="messageBox" @scroll="onScroll">
          <div class="more" v-if="!isCompleted">
            <a-button
              type="link"
              @click="getMessageList(currentConversation.conversationID)"
              >查看更多</a-button
            >
          </div>
          <div class="no-more" v-else @click="scrollToBottom">没有更多了</div>
          <message-item
            v-for="message in currentMessageList"
            :key="message.ID"
            :message="message"
          />
        </div>
        <div
          v-show="showScrollBottomTips"
          class="newMessageTips"
          @click="scrollToBottom"
        >
          回到最新位置
        </div>
        <a-row class="send-message">
          <send-message-box></send-message-box>
        </a-row>
      </div>
    </a-col>
    <a-col span="10" v-show="postcard" style="height:100%;">
      <post-card></post-card>
    </a-col>
  </a-row>
</template>

<script>
import Api from "@/api";
import { createNamespacedHelpers } from "vuex";
const { mapState, mapActions } = createNamespacedHelpers("im");
import MessageItem from "../message/message-item";
import SendMessageBox from "../message/send-message";
import PostCard from "./post-card";
export default {
  name: "currentConversation",
  data() {
    return {
      postcard: false,
      showScrollBottomTips: false,
      preScrollHeight: 0
    };
  },
  provide() {
    return {
      boxScrollToBottom: this.scrollToBottom,
      showPostCard: this.showPostCard
    };
  },
  updated() {
    this.keepMessageListOnBottom();
  },
  components: { MessageItem, SendMessageBox, PostCard },
  computed: {
    ...mapState([
      "currentConversation",
      "toAccount",
      "isCompleted",
      "currentMessageList"
    ]),
    name() {
      if (this.currentConversation.type === "C2C") {
        return this.currentConversation.userProfile.nick || this.toAccount;
      } else if (this.currentConversation.type === "GROUP") {
        return this.currentConversation.groupProfile.name || this.toAccount;
      } else if (this.currentConversation.conversationID === "@TIM#SYSTEM") {
        return "系统通知";
      }
      return this.toAccount;
    }
  },
  created() {},
  methods: {
    ...mapActions(["getMessageList"]),
    onScroll({ target: { scrollTop } }) {
      let $box = this.$refs.messageBox;
      if (!$box) {
        return;
      }
      if (this.preScrollHeight - $box.clientHeight - scrollTop < 20) {
        this.showScrollBottomTips = false;
      }
    },
    async scrollToBottom() {
      await this.$nextTick();
      if (this.$refs.messageBox) {
        let $box = this.$refs.messageBox;
        $box.scrollTop = $box.scrollHeight;
      }
      this.showScrollBottomTips = false;
    },
    async keepMessageListOnBottom() {
      let $box = this.$refs.messageBox;
      if (!$box) {
        return;
      }
      // 距离底部20px内强制滚到底部,否则提示有新消息
      if (this.preScrollHeight - $box.clientHeight - $box.scrollTop < 20) {
        this.showScrollBottomTips = false;
        await this.$nextTick();
        $box.scrollTop = $box.scrollHeight;
      } else {
        this.showScrollBottomTips = true;
      }
      this.preScrollHeight = $box.scrollHeight;
    },
    showPostCard() {
      this.postcard = !this.postcard;
    }
  }
};
</script>

<style scoped lang="scss">
.header {
  height: 48px;
  padding: 0 20px;
  position: relative;
  .arr-box {
    position: absolute;
    z-index: 10;
    cursor: pointer;
    right: 0;
    transform-origin: 100% 50%;
    &.right {
      transform: rotate(180deg);
    }
    &::before {
      pointer-events: none;
      position: absolute;
      content: "";
      width: 19px;
      height: 38px;
      right: 0;
      border-radius: 100% 0 0 100%/50%;
      border: 1px solid #e7e7e7;
      border-right: none;
      top: -8px;
      left: -5px;
    }
    .arrow {
      color: #a5b5c1;
      font-weight: bold;
    }
    &:hover {
      .arrow {
        color: #5cadff;
      }
    }
  }
}
.message-box {
  height: 400px;
  border-top: 1px solid #e7e7e7;
  overflow-y: auto;
  .no-more,
  .more {
    font-size: 12px;
    text-align: center;
  }
  .no-more {
    color: #a5b5c1;
    padding: 10px 10px;
  }
}
.newMessageTips {
  position: absolute;
  cursor: pointer;
  padding: 5px;
  width: 120px;
  margin: auto;
  left: 0;
  right: 0;
  bottom: 160px;
  font-size: 12px;
  text-align: center;
  border-radius: 10px;
  border: 1px solid #e9eaec;
  background-color: #fff;
  color: #2d8cf0;
}
.send-message {
  border-top: 1px solid #e7e7e7;
}
</style>
